import React from "react";
import styled from "styled-components";
import { BarChart, Edit, Search } from "react-feather";
import { Button, Tooltip } from "@mui/material";
import {
  MODULE_STATES,
  LIBRARY_MODAL_KEYS,
  JOB_TYPES,
} from "src/storage/constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useGlobalStore from "src/store/useGlobalStore";

const QuickChangeButton = styled(Button)`
  height: 22px;
  width: 22px;
  background: white;
  border: 1px solid ${(props) => (props?.$isDisabled ? "#eeeeee" : "gainsboro")};
  max-width: 22px;
  min-width: 22px;
  padding: 0px;
  border-radius: 5px;

  svg {
    color: ${(props) => (props?.$isDisabled ? "gainsboro" : "slategrey")};
  }

  &:hover {
    background: #eeeeee60;

    svg {
      color: slategrey;
    }
  }
`;

const shouldEditButtonDisplay = (
  moduleState,
  isManager,
  isMarketplaceModule,
  readOnly,
  isUserAManagerWhoCreatedModule,
) => {
  if (isMarketplaceModule) return false;
  if (isManager && !isUserAManagerWhoCreatedModule) return false;
  if (readOnly) return false;

  if (
    moduleState === MODULE_STATES.CLOSED ||
    moduleState === MODULE_STATES.IN_REVIEW
  ) {
    return false;
  }

  return true;
};

const shouldProgressButtonDisplay = (moduleState) => {
  if (
    moduleState === MODULE_STATES.LIVE ||
    moduleState === MODULE_STATES.CLOSED
  )
    return true;
  return false;
};

const QuickActions = ({
  moduleId,
  setModalState,
  isMarketplaceModule,
  moduleState, // one of MODULE_STATES
  isUserAManagerWhoCreatedModule,
  //
  displaySeperator = true,
}) => {
  const history = useHistory();
  const config = useGlobalStore((state) => state.config);
  const isManager = config?.user?.job === JOB_TYPES.SUPERVISOR;
  const { read_only: readOnly } = config.user;

  const handleEdit = () => {
    history.push(`/modules/quiz-builder/${moduleId}`);
  };

  const handlePreview = () => {
    setModalState({ id: moduleId, key: LIBRARY_MODAL_KEYS.PREVIEW });
  };

  const getEditTitleStr = () => {
    return isMarketplaceModule
      ? "🚫 Cannot Edit Marketplace Modules"
      : moduleState === MODULE_STATES.CLOSED
        ? "🚫 Cannot Edit Closed Modules"
        : readOnly
          ? "🚫 Read Only Users Cannot Edit Modules"
          : moduleState === MODULE_STATES.IN_REVIEW
            ? "🚫 Cannot Edit Modules In Review"
            : isManager && !isUserAManagerWhoCreatedModule
              ? "🚫 Managers do not have access to edit this module"
              : "Edit Module";
  };

  const editButtonShouldDisplay = shouldEditButtonDisplay(
    moduleState,
    isManager,
    isMarketplaceModule,
    readOnly,
    isUserAManagerWhoCreatedModule,
  );

  const progressButtonShouldDisplay = shouldProgressButtonDisplay(moduleState);

  const handleGoToReport = () => {
    return history.push(`/modules/progress/${moduleId}`);
  };

  return (
    <>
      <Tooltip title={getEditTitleStr()} arrow>
        <div>
          <QuickChangeButton
            $isDisabled={!editButtonShouldDisplay}
            disabled={!editButtonShouldDisplay}
            onClick={handleEdit}
          >
            <Edit height={12} />
          </QuickChangeButton>
        </div>
      </Tooltip>

      <Tooltip title="Preview Module" arrow>
        <div>
          <QuickChangeButton onClick={handlePreview}>
            <Search height={12} />
          </QuickChangeButton>
        </div>
      </Tooltip>
      <Tooltip
        title={
          !progressButtonShouldDisplay
            ? "🚫 Only live and closed modules have reports"
            : "View Progress Report"
        }
        arrow
      >
        <div>
          <QuickChangeButton
            $isDisabled={!progressButtonShouldDisplay}
            disabled={!progressButtonShouldDisplay}
            onClick={handleGoToReport}
          >
            <BarChart height={12} />
          </QuickChangeButton>
        </div>
      </Tooltip>

      {displaySeperator && (
        <div style={{ height: 22, width: 1, backgroundColor: "#eeeeee" }} />
      )}
    </>
  );
};

export default QuickActions;
